<template>
    <div class="input-wrapper" v-if="!fieldsToHide.includes(dataProperty)">
        <template v-if="inputType === 'select'">
            <div class="label-wrapper label-wrapper--select">
                <label v-bind:for="uniq_id">{{labelName}}</label>
            </div>
            <div class="form-group c-input extra-space" v-bind:class="css">
                <select
                        class="form-control"
                        @change="saveValue"
                        v-bind:id="uniq_id"
                        v-model="value"
                        v-bind="dataAttr"
                >
                    <option
                            v-for="option in extension.options"
                            v-bind:value="getOptionValue(option)"
                            :key="getOptionValue(option)"
                    >{{translate('Page1.' + getOptionText(option), getOptionText(option))}}</option>
                </select>
            </div>
        </template>
        <template v-else>
            <label v-bind:for="uniq_id" class="move-39px-right">{{labelName}}</label>
            <div class="input-group form-group c-input" v-bind:class="css">
        <span class="input-group-btn">
          <button class="btn btn-default" type="button" v-on:click="undo()" @blur="saveValue">
            <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"></span>
          </button>
        </span>

                <template v-if="suggestion === 'place'">
                    <vue-simple-suggest v-model="value" :list="suggestionListPlace"  @show-list="onShowList" @select="onSuggestSelect" display-attribute="description" ref="suggestComponent">
                        <input
                                ref="suggestComponentInput"
                                class="form-control"
                                tabindex="1"
                                v-bind:id="uniq_id"
                                v-bind:type="inputType"
                                v-bind="dataAttr"
                                v-model="value"
                                @blur="saveValue"
                                @keyup.enter="saveValue"
                        />

                        <div slot="suggestion-item" slot-scope="{ suggestion }">
                            <div>{{ suggestion.description }}</div>
                        </div>
                    </vue-simple-suggest>
                </template>
                <template v-else>
                    <input
                            class="form-control"
                            tabindex="1"
                            v-bind:id="uniq_id"
                            v-bind:type="inputType"
                            v-bind="dataAttr"
                            v-model="value"
                            @blur="saveValue"
                            @keyup.enter="saveValue"
                    />
                </template>

                <span class="input-group-btn" tabindex="2">
          <button class="btn btn-success" type="button">
            &nbsp;
            <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>&nbsp;
          </button>
        </span>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css'
    import getPlaceFromNominatim from '@/mixins/getPlaceFromNominatim.js';

    export default {
        name: "formInput",
        components: {
            VueSimpleSuggest
        },
        data: function () {
            return {
                uniq_id: null,
                change: null,
                prevChange: null,
                cssClass: {
                    'c-input--success': false,
                    'c-input--error': false,
                    'c-input--disable': false,
                    'c-input--scenario-val': false,
                },
                changes: [],
            }
        },
        props: {
            inputType: String, // set 'select'
            suggestion: String,
            fillValue: String,
            labelName: String,
            dataEntityId: Number,
            dataProperty: String,
            dataAttr: Object,
            dataCss: Object,
            changeId: {
                type: Number,
                default: -1
            },
        },
        watch: {
            fillValue: function(newValue) {
                this.value = newValue
                this.saveValue(true);
            }
        },
        methods: {
            getPlaceFromNominatim,
            async onShowList () {
                if(this.value === this.prevValue) {
                    this.$refs.suggestComponent.clearSuggestions();
                    this.$refs.suggestComponent.hideList();
                }
            },
            async onSuggestSelect (suggest) {
                this.$emit('suggestLat', suggest.lat);
                this.$emit('suggestLon', suggest.lon);

                this.change = suggest.description;
                await this.saveValue();
            },
            suggestionListPlace(inputValue) {
                return new Promise((resolve, reject) => {
                    let url = `${process.env.VUE_APP_NOMINATIM_SERVER || 'https://zzs.fel.cvut.cz/nominatim'}/search/?q=${inputValue}&format=json&limit=5&addressdetails=1`
                    fetch(url).then(response => {
                        if (!response.ok) {
                            reject()
                        }

                        response.json().then(json => {
                            let result = []
                            json.forEach((part) => {
                                result.push({id: part.osm_id, lat: part.lat, lon: part.lon, description: this.getPlaceFromNominatim(part)});
                            })
                            resolve(result)

                        }).catch(e => {
                            reject(e)
                        })
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            async saveValue(invokedByEmittedEvent) {
                if (this.value !== this.prevValue) {
                    this.prevValue = this.value;
                    this.changes.push(this.value);
                    this.disable();
                    let entityId = this.dataEntityId,
                        property = this.dataProperty,
                        value = this.value,
                        changeId = 0; // TODO
                    try {
                        //console.log("sendChangeIn: ", entityId, property, value, changeId, invokedByEmittedEvent)
                        await this.sendChange(entityId, property, value, changeId, invokedByEmittedEvent);
                        this.success();
                        setTimeout(this.clear, 800);
                        this.$eventHub.$emit('openMessageController', 'success', this.translate('Popups.text19'));
                    } catch (e) {
                        this.error();
                        setTimeout(this.clear, 800);
                        console.log('Saving was not succesfull:', e);
                        this.$eventHub.$emit('openMessageController', 'error', e);
                    }
                }

            },
            /**
             *
             * @param {number} entityId
             * @param {string} property
             * @param value
             * @param {boolean} isEditor
             */
            async sendChange(entityId, property, value, changeId, invokedByEmittedEvent) {
                return new Promise((resolve, reject)=>{
                    this.$emit('valueChange', {
                        payload: {entityId, property, value, changeId},
                        promise: {resolve, reject},
                        invokedByEmittedEvent: invokedByEmittedEvent,
                    });
                });
            },

            disable() {
                this.$set(this.cssClass, 'c-input--disable', true);
                this.$set(this.cssClass, 'c-input--success', false);
                this.$set(this.cssClass, 'c-input--error', false);
            },
            success() {
                this.$set(this.cssClass, 'c-input--disable', false);
                this.$set(this.cssClass, 'c-input--success', true);
                this.$set(this.cssClass, 'c-input--error', false);
            },
            error() {
                this.$set(this.cssClass, 'c-input--disable', false);
                this.$set(this.cssClass, 'c-input--success', false);
                this.$set(this.cssClass, 'c-input--error', true);

            },
            clear() {
                this.$set(this.cssClass, 'c-input--disable', false);
                this.$set(this.cssClass, 'c-input--success', false);
                this.$set(this.cssClass, 'c-input--error', false);
                this.change = null;

            },
            undo() {
                if (this.changes.length > 1) {
                    this.changes.pop();
                    this.change = this.changes[this.changes.length - 1];
                } else if (!this.changes.length) {
                    this.change = null;
                }
            },
            getOptionValue(option) {
                if(typeof option === 'string'){
                    return option;
                } else {
                    return option.value;
                }
            },
            getOptionText(option) {
                if(typeof option === 'string'){
                    return option;
                } else {
                    return option.text;
                }
            },
            ...mapActions(['sendCommand']),
        },
        mounted() {
            this.uniq_id = 'form_' + this._uid;
            this.changes.push(this.value);
            this.prevValue = this.value;
            if (this.dataProperty === 'datum') {
                this.value = this.date;
                this.saveValue(true);
            }

            if (this.isScenarioChange) {
                this.$set(this.cssClass, 'c-input--scenario-val', true);
            }
        },
        computed: {
            value: {
                get() {
                    if (this.change === null) {
                        let property = this.$store.getters.getPropertyValue(this.dataEntityId, this.dataProperty);
                        if(this.inputType == "select") {
                            return property;
                        } else {
                            return this.translate('Page1.'+property, property)
                        }
                    } else {
                        return this.change;
                    }
                },
                set(value) {
                    this.change = value;
                },
            },
            prevValue: {
                get() {
                    return this.prevChange;
                },
                set(value) {
                    this.prevChange = value;
                }
            },
            extension() {
                let ext = this.$store.getters.getPropertyExtension(this.dataEntityId, this.dataProperty) || {};
                
                console.log(this.dataProperty);
                if (ext.hasOwnProperty("options") && Array.isArray(ext.options)) {
                    if (ext.options.every(i => (typeof i === "string"))) {
                        ext.options = ext.options.map(opt  => this.translate('Page1.'+opt, opt));
                        ext.options = this.localeSort(ext.options);
                    } else {
                        console.log(ext.options);
                        ext.options = ext.options.map(opt  => ({text: this.translate('Page1.'+opt.text, opt.text), value: opt.value}));
                        ext.options =  ext.options.sort((a,b) => a.text.localeCompare(b.text));
                    }
                }
                return ext;
            },
            css() { // přepis class do jednoho objektu
                const cssClasses = {};
                Object.assign(cssClasses, this.cssClass);
                Object.assign(cssClasses, this.$props.dataCss);


                return cssClasses;
            },
            isEditorMode() {
                return this.$store.state.editMode;
            },
            isScenarioChange() {
                return this.isEditorMode && this.$store.getters.isPropertyScenarioChange(this.dataEntityId, this.dataProperty);
            },
            fieldsToHide() {
                return ["obec", "cp", "co"]
            },
            virtualTime(){
                return new Date(this.$store.state.time.time);
            },
            date(){
                const virtualTime = this.virtualTime;
                return `${virtualTime.getDate()}.${virtualTime.getMonth()+1}.${virtualTime.getFullYear()}`;
            }
        },

    }
</script>

<style scoped>
    /*.input-wrapper select{
            margin: 0 2.6875em;
        }*/
    .move-39px-right {
        padding-left: 39px;
    }
    .label-wrapper label {
        padding-left: 39px;
    }

    .label-wrapper--select label {
        padding-left: 0;
        margin: 0 2.6875em;
    }
    .extra-space {
        padding: 0 2.6875em;
    }
</style>

<style>
    .vue-simple-suggest.designed .suggestions{
        top: calc(100% + 35px);
    }

    .vue-simple-suggest.designed .input-wrapper input{
        border: 1px solid #ccc;
    }
</style>